import React from 'react';
import '../styles/About.css';

const About = () => (
  <section id="about" className="about-section" data-aos="fade-up">
    <h2>About Me</h2>
    <p>
      Hey! I'm Will, a student at The University of Wisconsin - Madison, studying Computer Science and Data Science. I love building things,
       exploring new technologies, and leveraging data to enhance processes.  
       When I'm not doing one of these things, you can find me exploring the outdoors, taking photos, or training for my next marathon.
    </p>
  </section>
);

export default About;